import { ListItem } from "./listItem";

export class Coverage {
	coverageTabs: CoverageTab[];

	constructor() {
		this.coverageTabs = new Array<CoverageTab>();
	}
}

export class CoverageTab {
	editFsaAnnualF: boolean;
	showActiveAtWork: boolean;
	showYesKnockout: boolean;
	showPayrollTaxStatus: boolean;
	showEnrollmentReason: boolean;
	showFlatTier: boolean;
	showManualCoverage: boolean;
	showCoverageDropdown: boolean;
	showFsaOption: boolean;
	showHsaOption: boolean;
	showCalcedTierSelectionGrid: boolean;
	showManualRate: boolean;
	showMiscDeductionCoverage: boolean;
	showCoveredMember: boolean;
	showMiscDeductionCoverageWarning: boolean;
	showAddDependent: boolean;
	addDependentLabel: string;
	coverageTabIndex: number;
	coverageTabName: string;
	currentCoverage: string;
	currentCoverageForDisplay: string;
	currentRate: string;
	currentRateForDisplay: string;
	currentDeductionFrequencyForDisplay: string;
	coveredMemberForDisplay: string;
	coveredMemberLabelForDisplay: string;
	activeAtWorkLabelForDisplay: string;
	payrollTaxStatusIsPreTax: boolean;
	flatTierLabelForDisplay: string;
	flatTierValue: string;
	enrollReasonForDisplay: string;
	enrollReasonAdditionalValue: string;
	manualCoverageLabelForDisplay: string;
	coverageDropdownLabelForDisplay: string;
	coverageDropdownDefaultValue: number;
	calcedTierLabelForDisplay: string;
	fsaMinValue: number;
	fsaMaxValue: number;
	fsaFrequencyForCalculation: number;
	fsaMessageForDisplay: string;
	fsaLimitForDisplay: string;
	fsaCalendarForDisplay: string;
	fsaEmpNoticeLabelForDisplay: string;
	fsaContributionNoticeLabelForDisplay: string;
	fsaNoteForDisplay: string;

	hsaFrequencyForDisplay: string;
	hsaMedTier: string;
	hsaContributionMax: number;
	hsaContributionMaxRemaining: number;
	hsaContributionsYearToDate: number;
	hsaContributionYearTotalEstimated: number;
	hsaNumDeductionsRemaining: number;
	hsaDisplayNextPlanYearMessage: boolean;
	hsaPlanYear: number;
	hsaPlanYearLast: number;
	hsaIsInitialEnrollment: boolean;
	payPeriodContribution: number;
	hsaContributionReductionAmount: number;
	hsaContributionYearRemaining: number;
	hsaDeductionReducedDate: string;
	hsaDisplayReductionMessage: boolean;
	hsaFirstDeductionDate: string;
	hsaLastFullDeductionDate: string;
	ReducedNumberOfDeductionsRemaining: number;
	hsaReducedNumDeductionsRemaining: number;
	manualRateLabelForDisplay: string;
	miscDeductionCoverageLabelForDisplay: string;
	miscDeductionWarningLabelForDisplay: string;
	miscDeductionCoverageMaxValue: number;
	coverageDropdownCollection: ListItem[];
	enrollReasonCollection: EnrollReason[];
	calcedTierOptions: CoverageDependent[];
	benefitNumber: number;
	uniqueID: string;
	isAddWizard: boolean;
	isBuyUpWizard: boolean;
	yesKnockoutLabelForDisplay: string;
	

	constructor() {
		this.editFsaAnnualF = false;
		this.showActiveAtWork = false;
		this.showYesKnockout = false;
		this.showPayrollTaxStatus = false;
		this.showEnrollmentReason = false;
		this.showFlatTier = false;
		this.showManualCoverage = false;
		this.showCoverageDropdown = false;
		this.showFsaOption = false;
		this.showHsaOption = false;
		this.showCalcedTierSelectionGrid = false;
		this.showManualRate = false;
		this.showMiscDeductionCoverage = false;
		this.showCoveredMember = false;
		this.showMiscDeductionCoverageWarning = false;
		this.showAddDependent = false;
		this.addDependentLabel = null;
		this.coverageTabIndex = null;
		this.coverageTabName = null;
		this.currentCoverage = null;
		this.currentCoverageForDisplay = null;
		this.currentRate = null;
		this.currentRateForDisplay = null;
		this.currentDeductionFrequencyForDisplay = null;
		this.coveredMemberForDisplay = null;
		this.coveredMemberLabelForDisplay = null;
		this.activeAtWorkLabelForDisplay = null;
		this.payrollTaxStatusIsPreTax = false;
		this.flatTierLabelForDisplay = null;
		this.flatTierValue = null;
		this.enrollReasonForDisplay = null;
		this.enrollReasonAdditionalValue = null;
		this.manualCoverageLabelForDisplay = null;
		this.coverageDropdownLabelForDisplay = null;
		this.coverageDropdownDefaultValue = null;
		this.fsaMinValue = null;
		this.fsaMaxValue = null;
		this.fsaFrequencyForCalculation = null;
		this.fsaMessageForDisplay = null;
		this.fsaLimitForDisplay = null;
		this.fsaCalendarForDisplay = null;
		this.fsaEmpNoticeLabelForDisplay = null;
		this.fsaContributionNoticeLabelForDisplay = null;
		this.fsaNoteForDisplay = null;
		this.hsaFrequencyForDisplay = null;
		this.hsaMedTier = null;
		this.hsaContributionMax = 0;
		this.hsaContributionMaxRemaining = 0;
		this.hsaContributionsYearToDate = 0;
		this.hsaContributionYearTotalEstimated = 0;
		this.hsaNumDeductionsRemaining = 0;
		this.hsaPlanYear = 0;
		this.hsaPlanYearLast = 0;
		this.hsaDisplayNextPlanYearMessage = false;
		this.hsaIsInitialEnrollment = false;
		this.manualRateLabelForDisplay = null;
		this.miscDeductionCoverageLabelForDisplay = null;
		this.miscDeductionWarningLabelForDisplay = null;
		this.miscDeductionCoverageMaxValue = null;
		this.uniqueID = null;
		this.isAddWizard = false;
		this.isBuyUpWizard = false;
		this.yesKnockoutLabelForDisplay = null;
		this.payPeriodContribution = 0;
		this.hsaContributionMax = 0;
		this.hsaContributionReductionAmount = 0;
		this.hsaContributionYearRemaining = 0;
		this.hsaContributionYearTotalEstimated = 0;
		this.hsaDeductionReducedDate = null;
		this.hsaDisplayReductionMessage = false;
		this.hsaFirstDeductionDate = null;
		this.hsaLastFullDeductionDate = null;
		this.ReducedNumberOfDeductionsRemaining = 0;
		this.hsaReducedNumDeductionsRemaining = 0;
	}
}

export class EnrollReason {
	additionalTextPrompt: string;
	description: string;
	id: number;
	requireAdditionalText: boolean;

	constructor() {
		this.additionalTextPrompt = null;
		this.description = null;
		this.id = 0;
		this.requireAdditionalText = false;
	}
}

export class CoverageDependent {
	dependentID: number;
	coveredMemberName: string;
	relationship: string;
	isRequired: boolean;
	isSelected: boolean;
	isTermAvailable: boolean;
	isAddAvailable: boolean;
	isCurrentlyActive: boolean;
	activeStatus: string;
	toggleLabelName: string;
	importantMessage: string;
	disabledMessage: string;

	constructor() {
		this.dependentID = null;
		this.coveredMemberName = null;
		this.relationship = null;
		this.isRequired = false;
		this.isSelected = false;
		this.isTermAvailable = false;
		this.isAddAvailable = false;
		this.isCurrentlyActive = false;
		this.activeStatus = null;
		this.toggleLabelName = null;
		this.disabledMessage = null;
	}
}

export class CoveragePayload {
	isActiveAtWork: string;
	isYesKnockout: string;
	isPretaxStatus: string;
	manualCoverageValue: number;
	coverageDropdownValue: number;
	fsaAnnualContribution: number;
	fsaEmpContribution: number;
	hsaContribution: number;
	hsaAnnualContribution: number;
	hsaEmpContribution: number;
	manualRateValue: number;
	miscDedCoverageValue: number;
	enrollReasonID: number;
	enrollReasonAdditional: string;
	selectedDependentIds: number[];
	changingTaxStatusOnly: boolean;

	constructor() {
		this.isActiveAtWork = '';
		this.isYesKnockout = '';
		this.isPretaxStatus = '';
		this.manualCoverageValue = 0;
		this.coverageDropdownValue = 0;
		this.fsaAnnualContribution = 0;
		this.fsaEmpContribution = 0;
		this.hsaContribution = 0;
		this.hsaAnnualContribution = 0;
		this.hsaEmpContribution = 0;
		this.manualRateValue = 0;
		this.miscDedCoverageValue = 0;
		this.enrollReasonID = 0;
		this.enrollReasonAdditional = '';
		this.selectedDependentIds = [];
		this.changingTaxStatusOnly = false;
	}
}
